import React from 'react';
import styled from 'styled-components';
import MenuItem from "../invoned/atoms/menu/MenuItem";
import Menu from "../invoned/atoms/menu/Menu";
import { getAppThemeName } from "../../../services/appTheme";
import ListItem from "../atoms/ListItem";
const StyledMenu = styled(Menu) `
  display: ${props => props.appThemeName === "inkassier" ? "none" : "flex"};
  justify-content: center;
  display: none !important;
  
  @media only screen and (min-width: 768px) {
    display: ${props => props.appThemeName === "inkassier" ? "none" : "flex"};
  }
  
  @media only screen and (min-width: 1200px) {
    justify-content: normal;
  }
`;
const FooterMenu = () => {
    return (React.createElement(StyledMenu, { appThemeName: getAppThemeName() },
        React.createElement(ListItem, null,
            React.createElement(MenuItem, { href: "./" }, "\u00A9 2021 KNNS B.V.")),
        React.createElement(ListItem, null,
            React.createElement(MenuItem, { href: "./" }, "Privacy statement"))));
};
export default FooterMenu;
